<template>
  <div id="header">
    <div class="left" @click="toggleMenu">
      <svgicon src="svg/menu.svg" :width=25 :height=25 v-if="!$store.state.showMenu"></svgicon>
      <svgicon src="svg/back.svg" :width=25 :height=25 v-if="$store.state.showMenu"></svgicon>
    </div>
    <div class="center">{{ $t($store.state.headerTitle) }}</div>
    <div class="right" v-if="User.token" @click="toProfile">
      <svgicon src="svg/user.svg" :width=25 :height=25 v-if="User.token"></svgicon>
    </div>
    <div class="right" v-if="!User.token">
    </div>
  </div>
</template>

<script>

  import User from '../../../core/User';

  export default {

    name: "headerComponent",

    data() {
      return {
        User
      };
    },

    methods: {
      toggleMenu() {
        this.$store.state.showMenu = !this.$store.state.showMenu;
      },
      toProfile() {
        this.$router.push("/profile");
      }
    }

  }

</script>

<style lang="scss" scoped>

  #header {
    height: 60px;
    background-color: #001722;
    color: white;
    display: flex;
    flex-shrink: 0;
    z-index: 1;
  }

  .left, .right {
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .center {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .svgicon {
    fill: #808b91;
  }

</style>